export default "__VITE_ASSET__BQCZpxqZ__"